<template>
  <v-container fluid class="px-0">
    <v-row dense>
      <v-col cols="3">
        <TextFieldRef :label="$t('ELE0139')" :value="itemComputed.inspStatus" />
      </v-col>
      <v-col cols="3">
        <TextFieldRef :label="$t('ELE0175')" right :value="itemComputed.inspQty" />
      </v-col>
      <v-col cols="3">
        <TextFieldRef :label="$t('ELE0119')" right :value="itemComputed.acceptanceQty" />
      </v-col>
    </v-row>
    <v-row dense class="pt-4">
      <v-col>
        <TextFieldRef :label="$t('ELE0050')" right :value="itemComputed.lotQty" />
      </v-col>
      <v-col>
        <TextFieldRef :label="$t('ELE0171')" right :value="itemComputed.sampleSize" />
      </v-col>
      <v-col>
        <TextFieldRef :label="$t('ELE0172')" right :value="itemComputed.acQty" />
      </v-col>
      <v-col>
        <TextFieldRef :label="$t('ELE0173')" right :value="itemComputed.reQty" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef.vue'

export default {
  name: 'LotInspInformationForm',

  components: { TextFieldRef },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    itemComputed: {
      get() {
        return this.item
      },
    },
  },
}
</script>
